import React, { useContext } from 'react';
import styles from '../../../../../styles/components/Modal/Employees/components/LeadFieldAccessTab.module.css';
import { LangContext } from '../../../../../context/LangContext';
import { ThemeContext } from '../../../../../context/ThemeContext';
import { getLeadFieldAccessOptions } from '../../../../../utils/leadFieldAccess';

const translations = {
    ru: {
        heading: 'Доступ к полям лида',
        description: 'Hide скрывает значение и действия, View оставляет только просмотр и копирование, Edit сохраняет текущее поведение поля.',
    },
    en: {
        heading: 'Lead Field Access',
        description: 'Hide masks the value and actions, View keeps read and copy only, Edit preserves the current field behavior.',
    },
};

export const LeadFieldAccessTab = ({
    sections,
    leadFieldAccess,
    onLeadFieldAccessChange,
}) => {
    const { langSelected } = useContext(LangContext);
    const { theme } = useContext(ThemeContext);
    const t = translations[langSelected] || translations.ru;
    const isDark = theme === 'dark';
    const accessOptions = getLeadFieldAccessOptions(langSelected);

    return (
        <div className={`${styles.container} ${isDark ? styles.darkContainer : ''}`}>
            <div className={styles.header}>
                <h2 className={`${styles.heading} ${isDark ? styles.darkHeading : ''}`}>{t.heading}</h2>
                <p className={`${styles.description} ${isDark ? styles.darkDescription : ''}`}>{t.description}</p>
            </div>

            {sections.map((section) => (
                <div key={section.key} className={`${styles.sectionCard} ${isDark ? styles.darkSectionCard : ''}`}>
                    <h3 className={`${styles.sectionHeading} ${isDark ? styles.darkSectionHeading : ''}`}>{section.label}</h3>
                    <div className={styles.fieldList}>
                        {section.fields.map((field) => (
                            <div key={field.key} className={`${styles.fieldRow} ${isDark ? styles.darkFieldRow : ''}`}>
                                <div className={styles.fieldMeta}>
                                    <span className={`${styles.fieldLabel} ${isDark ? styles.darkFieldLabel : ''}`} title={field.key}>{field.label}</span>
                                </div>
                                <div className={styles.fieldControl}>
                                    <div className={`${styles.modeSwitcher} ${isDark ? styles.darkModeSwitcher : ''}`} role="group" aria-label={field.label}>
                                        {accessOptions.map((option) => {
                                            const isActive = leadFieldAccess[field.key] === option.value;

                                            return (
                                                <button
                                                    key={option.value}
                                                    type="button"
                                                    className={`${styles.modeButton} ${isActive ? styles.modeButtonActive : ''} ${isDark ? styles.darkModeButton : ''} ${isActive && isDark ? styles.darkModeButtonActive : ''}`}
                                                    onClick={() => onLeadFieldAccessChange(field.key, option.value)}
                                                    aria-pressed={isActive}
                                                >
                                                    {option.label}
                                                </button>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
};
